import React, { useState, useEffect } from "react";
import * as S from "./styles";

export const FieldNumber = ({
  id,
  label,
  value: numericValue,
  empty,
  handleChange,
  type,
  readOnly,
  required,
  styles,
  showTooltip = false,
  titleWeight = "normal", // "bold" | "semibold" | "normal"
}) => {
  const [value, setValue] = useState(empty ? "" : numericValue || 0); // Inicializa con 0 si numericValue es undefined o null
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    if (isFocused) return; // No sobreescribir el input mientras el usuario está escribiendo
    if (numericValue !== undefined && numericValue !== null) {
      const formattedValue = numericValue.toString().replace(",", "."); // Cambiar coma por punto
      setValue(empty ? "" : formattedValue);
    } else {
      setValue(empty ? "" : "0");
    }
  }, [empty, numericValue, isFocused]);

  const editing = !readOnly;
  const numberOptions = {
    style: type === "currency" ? "currency" : "decimal",
    minimumFractionDigits: type === "int" ? 0 : 2,
    maximumFractionDigits: type === "int" ? 0 : 2,
    currency: "EUR",
  };

  return (
    <S.Container>
      {label && <S.Title $weight={titleWeight}>{label}</S.Title>}
      <S.InputContainer title={showTooltip ? value : ""}>
        <S.InputWrapper>
          {editing ? (
            <S.Input
              type="number"
              value={value}
              onFocus={() => setIsFocused(true)}
              onBlur={() => {
                setIsFocused(false);
                if (type === "float" || type === "currency") {
                  const parsed = parseFloat(value);
                  const rounded = isNaN(parsed) ? 0 : parseFloat(parsed.toFixed(2));
                  handleChange(id, rounded);
                }
              }}
              onChange={(e) => {
                const val = e.target.value;
                setValue(val); // Actualizar el display inmediatamente sin redondear
                const parsedValue = type === "float" || type === "currency"
                  ? parseFloat(val) || 0
                  : Number(val);
                handleChange(id, val ? parsedValue : 0);
              }}
              step={type === "int" ? 1 : 0.01}
              min="0"
              required={required}
              styles={styles}
            />
          ) : empty ? (
            ""
          ) : (
            <S.Text>
              {Number(value).toLocaleString("es-ES", numberOptions)}
            </S.Text>
          )}
        </S.InputWrapper>
        <input
          className="hidden"
          name={id}
          type="number"
          defaultValue={value}
        />
      </S.InputContainer>
    </S.Container>
  );
};